export default __webpack_public_path__ + "static/media/android_2.ab58094f.jpg";